'use strict';

/**
 * Contrôleur de la page "Mon compte"
 */
(function() {
  angular
    .module('observatoireApp')
    .controller('MonCompteController', MonCompteController);

  MonCompteController.$inject = ['$scope', 'Auth', '$state', '$window', 'StorageService', '$http'];

  function MonCompteController($scope, Auth, $state, $window, StorageService, $http) {
    var vm = this;
    
    // Données du modèle
    vm.user = {};
    vm.error = null;
    vm.success = null;
    vm.updateInProgress = false;
    vm.passwordData = { oldPassword: '', newPassword: '', confirmPassword: '' };
    vm.showOldPwd = false;
    vm.showNewPwd = false;
    vm.showConfirmPwd = false;
    vm.photoUploading = false;
    
    // Statistiques utilisateur
    vm.stats = {
      views: 0,
      downloads: 0,
      visits: 0,
      downloadedItems: [],
      recentActivity: []
    };
    vm.chartOptions = {
      responsive: true,
      maintainAspectRatio: false
    };
    vm.chartData = [];
    vm.chartLabels = [];
    vm.loadingStats = false;

    // Filtres pour les téléchargements
    vm.downloadFilters = {
      type: null,
      search: '',
      sort: 'date',
      direction: 'desc'
    };
    
    // Actions disponibles
    vm.saveProfile = saveProfile;
    vm.changePassword = changePassword;
    vm.triggerFileInput = triggerFileInput;
    vm.onFileSelected = onFileSelected;
    // Suppression des méthodes liées aux statistiques
    // vm.refreshStats = refreshStats;
    // vm.filterDownloads = filterDownloads;
    // vm.resetStats = resetStats;
    // vm.sortDownloads = sortDownloads;

    // Initialisation
    activate();
    
    /**
     * Initialisation du contrôleur
     */
    function activate() {
      var token = Auth.getToken();

      if (!token || token.startsWith('simulated-jwt-token-')) {
        $state.go('login');
        return;
      }

      // Source principale : backend (données fraîches depuis la BDD)
      $http.get('/api/users/profile', {
        headers: { 'Authorization': 'Bearer ' + token }
      }).then(function(response) {
          vm.user = response.data || {};
          // Mettre à jour le cache localStorage avec les données fraîches
          StorageService.set('currentUser', angular.toJson(vm.user));

      }).catch(function(err) {
          if (err.status === 401 || err.status === 403 || err.status === 404) {
            // Token invalide/expiré : ré-authentification
            Auth.logout();
          } else {
            // Backend indisponible : utiliser localStorage comme fallback
            var stored = StorageService.get('currentUser');
            if (stored) {
              try { vm.user = angular.fromJson(stored); }
              catch(e) { vm.error = 'Impossible de charger le profil'; }
            } else {
              vm.error = 'Impossible de charger le profil utilisateur';
            }
          }
      });
    }
    
    /**
     * Ouvre le sélecteur de fichier pour changer la photo
     */
    function triggerFileInput() {
      document.getElementById('profileImageInput').click();
    }

    /**
     * Lit le fichier image sélectionné et le prévisualise
     */
    function onFileSelected(input) {
      if (!input.files || !input.files[0]) return;
      var file = input.files[0];
      if (!file.type.startsWith('image/')) {
        $scope.$apply(function() { vm.error = 'Veuillez sélectionner un fichier image valide'; });
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        $scope.$apply(function() { vm.error = 'La taille de l\'image ne doit pas dépasser 2 Mo'; });
        return;
      }
      var reader = new FileReader();
      reader.onload = function(e) {
        var base64Image = e.target.result;
        $scope.$apply(function() {
          vm.user.profileImage = base64Image;
          vm.error = null;
          vm.photoUploading = true;
        });
        // Upload immédiat vers le backend
        var token = Auth.getToken();
        $http.post('/api/users/profile/photo',
          { photo: base64Image },
          { headers: { 'Authorization': 'Bearer ' + token } }
        ).then(function(response) {
          vm.success = 'Photo de profil mise à jour avec succès';
          vm.user.profileImage = response.data.profileImage;
          StorageService.set('currentUser', angular.toJson(vm.user));
          vm.photoUploading = false;
        }).catch(function(err) {
          vm.error = 'Erreur lors de l\'envoi de la photo';
          vm.photoUploading = false;
        });
      };
      reader.readAsDataURL(file);
    }

    function saveProfile() {
      vm.updateInProgress = true;
      vm.error = null;
      vm.success = null;
      
      console.log('Sauvegarde du profil:', vm.user);
      
      // Appel à l'API pour mettre à jour l'utilisateur
      Auth.updateUser(vm.user)
        .then(function(result) {
          vm.success = 'Profil mis à jour avec succès';
          console.log('Profil mis à jour:', result);
        })
        .catch(function(err) {
          vm.error = 'Erreur lors de la mise à jour du profil';
          console.error(err);
        })
        .finally(function() {
          vm.updateInProgress = false;
        });
    }
    
    /**
     * Changement de mot de passe
     */
    function changePassword(passwordData) {
      if (!passwordData || !passwordData.newPassword || !passwordData.oldPassword) {
        vm.error = 'Les mots de passe sont requis';
        return;
      }
      
      if (passwordData.newPassword !== passwordData.confirmPassword) {
        vm.error = 'Le nouveau mot de passe et sa confirmation ne correspondent pas';
        return;
      }
      
      vm.updateInProgress = true;
      vm.error = null;
      vm.success = null;
      
      // Appel à l'API pour changer le mot de passe
      Auth.changePassword(passwordData.oldPassword, passwordData.newPassword)
        .then(function() {
          vm.success = 'Mot de passe modifié avec succès';
          // Réinitialiser le formulaire
          passwordData.oldPassword = '';
          passwordData.newPassword = '';
          passwordData.confirmPassword = '';
        })
        .catch(function(err) {
          vm.error = 'Erreur lors du changement de mot de passe';
          console.error(err);
        })
        .finally(function() {
          vm.updateInProgress = false;
        });
    }
    /**
     * Rafraîchit les statistiques utilisateur
     */
    function refreshStats() {
      vm.loadingStats = true;
      
      UserStatsService.getStats()
        .then(function(stats) {
          vm.stats = stats;
          console.log('Statistiques utilisateur chargées:', stats);
          
          // Préparer les données pour les graphiques
          prepareChartData();
        })
        .catch(function(err) {
          console.error('Erreur lors du chargement des statistiques:', err);
        })
        .finally(function() {
          vm.loadingStats = false;
        });
      
      // Récupérer les données depuis l'API si l'utilisateur a un ID
      if (vm.user && vm.user.id) {
        UserStatsService.fetchStatsFromAPI(vm.user.id)
          .then(function(stats) {
            vm.stats = stats;
            console.log('Statistiques utilisateur chargées depuis l\'API:', stats);
            
            // Préparer les données pour les graphiques
            prepareChartData();
          })
          .catch(function(err) {
            console.error('Erreur lors du chargement des statistiques depuis l\'API:', err);
          });
      }
    }
    
    /**
     * Prépare les données pour les graphiques
     */
    function prepareChartData() {
      // Graphique d'activité
      var activityData = {
        labels: ['Visites', 'Visualisations', 'Téléchargements'],
        datasets: [{
          label: 'Statistiques utilisateur',
          data: [vm.stats.visits, vm.stats.views, vm.stats.downloads],
          backgroundColor: [
            'rgba(54, 162, 235, 0.6)',
            'rgba(75, 192, 192, 0.6)',
            'rgba(255, 206, 86, 0.6)'
          ],
          borderColor: [
            'rgba(54, 162, 235, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(255, 206, 86, 1)'
          ],
          borderWidth: 1
        }]
      };
      
      vm.chartData = activityData;
    }
    
    /**
     * Filtre la liste des téléchargements
     */
    function filterDownloads() {
      return vm.stats.downloadedItems.filter(function(item) {
        // Filtre par type
        if (vm.downloadFilters.type && item.type !== vm.downloadFilters.type) {
          return false;
        }
        
        // Filtre par recherche
        if (vm.downloadFilters.search && item.name.toLowerCase().indexOf(vm.downloadFilters.search.toLowerCase()) === -1) {
          return false;
        }
        
        return true;
      });
    }
    
    /**
     * Trie la liste des téléchargements
     */
    function sortDownloads(field) {
      if (vm.downloadFilters.sort === field) {
        // Inverser la direction du tri si on clique sur la même colonne
        vm.downloadFilters.direction = vm.downloadFilters.direction === 'asc' ? 'desc' : 'asc';
      } else {
        vm.downloadFilters.sort = field;
        vm.downloadFilters.direction = 'asc';
      }
    }
    
    /**
     * Réinitialise les statistiques utilisateur
     */
    function resetStats() {
      if (confirm('Êtes-vous sûr de vouloir réinitialiser toutes vos statistiques ?')) {
        UserStatsService.resetStats();
        refreshStats();
        vm.success = 'Statistiques réinitialisées avec succès';
      }
    }
  }
})();
